import React, { useEffect, useState }from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import { faEnvelope} from '@fortawesome/free-solid-svg-icons'
import { faPhone} from '@fortawesome/free-solid-svg-icons'
import { faGlobe} from '@fortawesome/free-solid-svg-icons'
//import githubIcon from '../Images/gitgub.svg'
import coverPhotoContImage from '../Images/default-cover.gif'
import profilePictureContImage from '../Images/defprofile.png'

// firebase
import {db, app} from '../firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";
import { getDatabase, ref, query as dbQuery, orderByChild, equalTo, onValue } from "firebase/database";

//routers
import {useNavigate } from "react-router-dom";


function ProfileComp(props) {


  //states
  const [loggedInUser, setLoggedInUser] = useState("");
  const [userNationality, setNationality] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userWebsite, setUserWebsite] = useState("");
  const [userGithub, setUserGithub] = useState("");
  const [userAbout, setUserAbout] = useState("");
  const [userExpectation, setUserExpectation] = useState("");
  const [userCourse, setUserCourse] = useState("");
  const [userSessionTime, setUserSessionTime] = useState("");
  const [userClassType, setUserClassType] = useState("");
  const [admissionNumber, setAdmissionNumber] = useState("");
  const [verificationEntries, setVerificationEntries] = useState([]);
  const [verificationLoading, setVerificationLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);


  //update user state
  const [updateHighSchoolMath, setHighSchoolMath] = useState("");
  const [updateEducationLevel,setEducationLevel] = useState("");

  //profile pic & cover
  const [userProfilePicture, setProfilePicture] = useState(profilePictureContImage);
  const [userCoverPicture, setCoverPicture] = useState(coverPhotoContImage);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
        //if user is logged in 
        const uid = user.uid;

        const q = query(collection(db, "users"), where("userId", "==", uid));
        getDocs(q).then((QuerySnapshot)=>{
            QuerySnapshot.forEach((doc)=>{
            setIsLoading(true);
            const username = doc.data().bio;
            const nationality = doc.data().nationality;
            const whyInterested = doc.data().whyInterested;
            const aboutMe = doc.data().aboutMe;
            const phoneNumber = doc.data().phoneNumber;
            const userEmail = doc.data().userEmail;
            const userWebsite = doc.data().userWebsite;
            const userGithub = doc.data().userGithub;
            const admissionNumber = doc.data().admissionNumber;
            const highSchoolMath =  doc.data().highSchoolMath;
            const educationLevel = doc.data().educationLevel;

            const course = doc.data().course;
            const sessionTime = doc.data().sessionTime;
            const classType = doc.data().classType;

            const profilePic = doc.data().profilePic;
            const coverPhoto = doc.data().coverPhoto;       

            setLoggedInUser(username);
            setNationality(nationality);
            setUserEmail(userEmail);
            setUserPhone(phoneNumber);
            setUserWebsite(userWebsite);
            setUserGithub(userGithub);
            setAdmissionNumber(admissionNumber ? String(admissionNumber).trim() : "");
            setUserAbout(aboutMe);
            setUserExpectation(whyInterested);

            setUserCourse(course);
            setUserSessionTime(sessionTime);
            setUserClassType(classType);

            //update
            setHighSchoolMath(highSchoolMath);
            setEducationLevel(educationLevel);

            //pictures

            let myxx = profilePic + "1";
            let myYY = coverPhoto + "1";

    
            if(myxx === "undefined1"){
              setProfilePicture(profilePictureContImage);         
            }else{
              setProfilePicture(profilePic);
            }

            //
            if(myYY === "undefined1"){
              setCoverPicture(coverPhotoContImage);
            }else{
              setCoverPicture(coverPhoto);
            }
            setIsLoading(false);
    
            })
        })

        } else {
        // User is signed out
        setIsLoading(false);
        }
    });

    return () => unsubscribe();
  }, [auth]);


  //go to edit profile page
  let navigate = useNavigate();
  function goToEdtAccount(){
    navigate("/edit-profile")
  }


  const formatVerificationDate = (value) => {
    if (!value) return "Unknown date";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return String(value);
    return parsed.toLocaleString();
  };

  const formatVerificationLocation = (entry) => {
    const parts = [entry.city, entry.region, entry.country].filter(Boolean);
    if (parts.length === 0) return "Location unknown";
    return parts.join(", ");
  };

  useEffect(() => {
    if (!admissionNumber) {
      setVerificationEntries([]);
      setVerificationLoading(false);
      return;
    }
    setVerificationLoading(true);
    const realtimeDb = getDatabase(app);
    const searchesRef = ref(realtimeDb, "verificationSearches");
    const admissionKey = String(admissionNumber).trim();
    const normalize = (value) => String(value || "").trim();
    const flattenEntries = (payload) => {
      if (!payload || typeof payload !== "object") return [];
      const output = [];
      Object.entries(payload).forEach(([key, value]) => {
        if (!value || typeof value !== "object") return;
        if (Object.prototype.hasOwnProperty.call(value, "admissionNumber")) {
          output.push({ id: key, ...value });
          return;
        }
        Object.entries(value).forEach(([nestedKey, nestedValue]) => {
          if (nestedValue && typeof nestedValue === "object") {
            output.push({ id: `${key}_${nestedKey}`, ...nestedValue });
          }
        });
      });
      return output;
    };

    const unsubscribe = onValue(searchesRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setVerificationEntries([]);
        setVerificationLoading(false);
        return;
      }
      const entries = flattenEntries(data).filter(
        (entry) => normalize(entry.admissionNumber) === admissionKey
      );
      entries.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setVerificationEntries(entries);
      setVerificationLoading(false);
    }, (error) => {
      console.error("Verification search error:", error);
      setVerificationEntries([]);
      setVerificationLoading(false);
    });
    return () => unsubscribe();
  }, [admissionNumber]);

  return (
    <div>

        <div className='profileComp'>
            {isLoading ? (
              <div className='profileSkeleton'>
                <div className='profileSkeletonHero'>
                  <div className='profileSkeletonCover' />
                  <div className='profileSkeletonContent'>
                    <div className='profileSkeletonAvatar' />
                    <div className='profileSkeletonText'>
                      <div className='skeleton-line skeleton-line--title' />
                      <div className='skeleton-line' />
                      <div className='profileSkeletonTags'>
                        <div className='skeleton-pill' />
                        <div className='skeleton-pill' />
                        <div className='skeleton-pill' />
                      </div>
                    </div>
                    <div className='skeleton-button' />
                  </div>
                </div>

                <div className='profileGrid'>
                  <div className='profileCard'>
                    <div className='skeleton-line skeleton-line--title' />
                    <div className='skeleton-line' />
                    <div className='skeleton-line' />
                  </div>
                  <div className='profileCard'>
                    <div className='skeleton-line skeleton-line--title' />
                    <div className='skeleton-line' />
                    <div className='skeleton-line' />
                    <div className='skeleton-line' />
                  </div>
                  <div className='profileCard profileCardWide'>
                    <div className='skeleton-line skeleton-line--title' />
                    <div className='profileSkeletonGrid'>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <div className='profileSkeletonTile' key={`profile-tile-${index}`}>
                          <div className='skeleton-line' />
                          <div className='skeleton-line' />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className='profileHero'>
                    <div className='profileHeroCover'>
                      <img src={userCoverPicture} alt="" />
                      <div className='profileHeroOverlay'></div>
                    </div>

                    <div className='profileHeroContent'>
                      <div className='profileAvatar'>
                        <img src={userProfilePicture} alt="" />
                      </div>

                      <div className='profileHeroText'>
                        <h3>{loggedInUser || "Student"}</h3>
                        <p><FontAwesomeIcon icon={faMapMarkerAlt} className="profileLocationIcon"/> {userNationality || "Location not set"}</p>
                        <div className='profileHeroTags'>
                          <span>{userCourse || "Course not set"}</span>
                          <span>{userClassType || "Class type"}</span>
                          <span>{userSessionTime || "Session time"}</span>
                        </div>
                      </div>

                      <button onClick={goToEdtAccount} className="profileEditButton">Edit Profile</button>
                    </div>
                </div>

                <div className='profileGrid'>
                  <div className='profileCard'>
                    <div className='profileCardHeader'>
                      <h6><FontAwesomeIcon icon={faInfoCircle} className=""/> About</h6>
                    </div>
                    <p className='profileCardText'>{userAbout || "Tell us about yourself."}</p>

                    <div className='profileDivider'></div>

                    <h6 className='profileSectionTitle'>Expectations</h6>
                    <p className='profileCardText'>{userExpectation || "Share what you hope to achieve during your studies."}</p>
                  </div>

                  <div className='profileCard'>
                    <div className='profileCardHeader'>
                      <h6>Contact</h6>
                    </div>

                    <div className='profileContactItem'>
                      <FontAwesomeIcon icon={faEnvelope} />
                      <div>
                        <span>Email</span>
                        <p>{userEmail || "Not provided"}</p>
                      </div>
                    </div>

                    <div className='profileContactItem'>
                      <FontAwesomeIcon icon={faPhone} />
                      <div>
                        <span>Phone</span>
                        <p>{userPhone || "Not provided"}</p>
                      </div>
                    </div>

                <div className='profileContactItem'>
                  <FontAwesomeIcon icon={faInfoCircle} />
                  <div>
                    <span>Admission Number</span>
                    <p>{admissionNumber || "Not assigned yet"}</p>
                  </div>
                </div>

                <div className='profileContactItem'>
                  <FontAwesomeIcon icon={faGlobe} />
                  <div>
                    <span>Website</span>
                    {userWebsite ? (
                      <a href={userWebsite} target="_blank" rel="noreferrer">{userWebsite}</a>
                    ) : (
                      <p>Not provided</p>
                    )}
                  </div>
                </div>

                <div className='profileContactItem'>
                  <FontAwesomeIcon icon={faGlobe} />
                  <div>
                    <span>GitHub</span>
                    {userGithub ? (
                      <a href={userGithub} target="_blank" rel="noreferrer">{userGithub}</a>
                    ) : (
                      <p>Not provided</p>
                    )}
                  </div>
                </div>
                  </div>

                  <div className='profileCard profileCardWide'>
                    <div className='profileCardHeader'>
                      <h6>Document Verification Activity</h6>
                      <p className='profileCardText'>This shows when someone searches or verifies your student ID or certificate.</p>
                    </div>

                    <div className='profileVerificationList'>
                      {!admissionNumber && (
                        <p className='profileCardText'>Admission number not found. Verification history will show here once available.</p>
                      )}
                      {admissionNumber && verificationLoading && (
                        <p className='profileCardText'>Loading verification activity...</p>
                      )}
                      {admissionNumber && !verificationLoading && verificationEntries.length === 0 && (
                        <p className='profileCardText'>No verification searches yet.</p>
                      )}
                      {verificationEntries.map((entry) => (
                        <div key={entry.id} className='profileVerificationItem'>
                          <div className='profileVerificationHeader'>
                            <div>
                              <h6>{(entry.type || "Document").replace(/^\w/, (c) => c.toUpperCase())} verification</h6>
                              <p>{formatVerificationDate(entry.timestamp)}</p>
                            </div>
                            <span className={`profileVerificationBadge ${entry.found ? "found" : "missing"}`}>
                              {entry.status || (entry.found ? "Found" : "Not found")}
                            </span>
                          </div>
                          <div className='profileVerificationMeta'>
                            <span>{formatVerificationLocation(entry)}</span>
                            <span>IP: {entry.ip || "Unknown"}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
    </div>
  )
}

export default ProfileComp
